import SlideshowDesignerView from './SlideshowDesignerView';

export default SlideshowDesignerView;
